import React, { useEffect, useState } from 'react';

const GreetingsAdmin = () => {
    const [greetings, setGreetings] = useState([]);
    const [newGreeting, setNewGreeting] = useState('');

    useEffect(() => {
        fetch('http://localhost:5000/api/greetings')
            .then(res => res.json())
            .then(data => setGreetings(data));
    }, []);

    const addGreeting = () => {
        fetch('http://localhost:5000/api/greetings', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ text: newGreeting }),
        })
            .then(res => res.json())
            .then(data => setGreetings([...greetings, data]));
        setNewGreeting('');
    };

    const deleteGreeting = (id) => {
        fetch(`http://localhost:5000/api/greetings/${id}`, { method: 'DELETE' })
            .then(() => setGreetings(greetings.filter(g => g.id !== id)));
    };

    return (
        <div>
            <h2>Manage Greetings</h2>
            <input
                type="text"
                value={newGreeting}
                onChange={(e) => setNewGreeting(e.target.value)}
                placeholder="Enter new greeting"
            />
            <button onClick={addGreeting}>Add Greeting</button>
            <ul>
                {greetings.map((g) => (
                    <li key={g.id}>
                        {g.text}{' '}
                        <button onClick={() => deleteGreeting(g.id)}>Delete</button>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default GreetingsAdmin;
